import * as React from 'react';

export default (props) => {
  let strokeColor;

  if (props.color) {
    strokeColor = props.color;
  } else {
    switch (props.state) {
      case 'hover':
        strokeColor = '#0A132B';
        break;
      case 'static':
        strokeColor = '#6C7280';
        break;
      case 'active':
        strokeColor = '#0067F4';
        break;
      default:
        strokeColor = '#B5BFD2';
    }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      fill="none"
    >
      <path stroke={strokeColor} strokeWidth="2" d="M11.5 20a7 7 0 0 0 7-7h-7V6a7 7 0 0 0 0 14Z" />
      <path stroke={strokeColor} strokeWidth="2" d="M21.5 10a7 7 0 0 0-7-7v7h7Z" />
    </svg>
  );
};
